var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 53,
    viewBox: "0 0 61 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2754 42.8403V34.1761C40.2754 33.8821 40.5075 33.6191 40.8014 33.5882C44.0041 33.2323 49.5894 33.2323 52.792 33.5882C53.086 33.6191 53.318 33.8821 53.318 34.1761V42.8403C53.318 43.1342 53.086 43.3972 52.792 43.4282C50.7033 43.6603 47.5626 43.7376 44.7622 43.6757",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0703 32.3199V30.1229C42.0703 27.5237 44.1899 25.4041 46.8047 25.4041C49.4194 25.4041 51.539 27.5237 51.539 30.1229V32.3199M43.8341 32.1961V30.1229C43.8341 28.4984 45.1647 27.1833 46.7892 27.1833C48.4137 27.1833 49.7443 28.4984 49.7443 30.1229V32.1961",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9823 37.7969C47.9823 37.1471 47.4407 36.6211 46.7909 36.6211C46.1411 36.6211 45.5996 37.1471 45.5996 37.7969C45.5996 38.4468 45.8472 38.6015 46.1875 38.8181V39.5762C46.1875 39.9011 46.4505 40.1641 46.7755 40.1641C47.1004 40.1641 47.3634 39.9011 47.3634 39.5762V38.8181C47.7192 38.6169 47.9513 38.2302 47.9513 37.7969H47.9823Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7532 35.2915V39.0047C15.7532 40.2424 14.7321 41.2481 13.4943 41.2481H6.11434C4.86113 41.2481 3.85547 40.2424 3.85547 39.0047V35.2915",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74219 23.8901C6.1754 24.6483 6.88709 25.2516 7.79992 25.5147L14.4992 27.4486",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3287 29.0876H18.168",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0357 16.0305H10.1836",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3107 35.2926H4.21144C3.14389 35.2926 2.29295 34.4416 2.29295 33.3741V24.3077C2.29295 22.3582 2.98918 20.4552 4.25786 18.939L6.7488 16.0303L0.838611 14.3903C0.126912 14.1892 -0.213465 13.3846 0.142384 12.7194L0.931441 11.265C1.28729 10.6307 1.92163 10.2439 2.6488 10.2439C3.37597 10.2439 7.38314 10.2439 9.44088 10.2439L11.6224 4.64312C12.6126 2.10576 15.0571 0.434814 17.7801 0.434814H36.439C39.1775 0.434814 41.622 2.10576 42.5967 4.64312L44.7628 10.2439H51.5239C52.2511 10.2439 52.9164 10.6461 53.2568 11.265L54.0613 12.7348C54.4171 13.3846 54.0613 14.2046 53.3651 14.4058L47.4549 16.0458L49.9458 18.9544",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9453 21.8625H40.6762C39.1445 24.2761 36.3596 27.3241 33.6211 28.4999V31.161C33.6211 32.8165 33.7139 34.472 33.8996 36.112C34.4102 40.6761 36.8547 44.8226 40.6143 47.4992C42.8268 49.0773 45.1939 50.6244 46.803 51.2743C48.412 50.6244 50.7792 49.0773 53.0071 47.4992C56.7668 44.8226 59.2113 40.6916 59.7219 36.112C59.9075 34.472 60.0004 32.8165 60.0004 31.161V28.4999C57.2619 27.1848 54.477 24.2761 52.9607 21.8625H52.9453Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto.1276430d.svg";
export { ForwardRef as ReactComponent };